<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex flex-column">
                    <!-- Photo -->
                    <div role="group" class="form-group col-12 col-md-4">
                        <label class=""> {{ $t('photo') }}</label>
                        <GalleryPicker class="gallery-picker" v-model="user.photo" :ratioWidth="'1'" :ratioHeight="'1'" v-bind:class="{'is-invalid': errorValidator('Photo') === false }" :max="1"></GalleryPicker>
                    </div>
                    <!-- FirstName -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('firstName') }}</label>
                        <CInput type="text" v-model="user.firstName" :invalid-feedback="errorOutput['FirstName']" :is-valid="genericValidator(user.firstName, attemptedSubmit) && errorValidator('FirstName')"></CInput>
                    </div>
                    <!-- LastName -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('lastName') }}</label>
                        <CInput type="text" v-model="user.lastName" :invalid-feedback="errorOutput['LastName']" :is-valid="genericValidator(user.lastName, attemptedSubmit) && errorValidator('LastName')"></CInput>
                    </div>
                    <!-- Email -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('email') }}</label>
                        <CInput type="email" v-model="user.email" :invalid-feedback="errorOutput['Email']" :is-valid="genericValidator(user.email, attemptedSubmit) && errorValidator('Email')"></CInput>
                    </div>
                    <!-- PhoneNumber -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('phoneNumber') }}</label>
                        <CInput type="number" v-model="user.phoneNumber" :invalid-feedback="errorOutput['PhoneNumber']" :is-valid="errorValidator('PhoneNumber')"></CInput>
                    </div>
                    <!-- subscriptionExpiryDate -->
                    <div role="group" class="form-group col-12">
                        <label>{{ $t('subscriptionExpiryDate') }}</label>
                        <CInput type="date" v-model="user.date" :invalid-feedback="errorOutput['Date']" :is-valid="errorValidator('Date')"></CInput>
                    </div>
                    <!-- Role -->
                    <div role="group" class="form-group col-12" :class="{'disabled': baseUser}">
                        <label class=""> {{ $t('role') }}</label>
                        <SingleOptionDropdown v-model="user.role" :options="roles" :title="$t('role')" :index="1"></SingleOptionDropdown>
                    </div>
                    <!-- MaxStudents -->
                    <div v-if="user.role == COACH" role="group" class="form-group col-12">
                        <label class=""> {{ $t('maxStudents') }}</label>
                        <CInput type="number" v-model="user.maxStudents" :invalid-feedback="errorOutput['MaxStudents']" :is-valid="genericValidator(user.maxStudents, attemptedSubmit) && errorValidator('MaxStudents')"></CInput>
                    </div>
                </div>
                <!-- Action button + submitting -->  
                <div role="group" class="form-group col-12 d-flex justify-content-end">
                    <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                    <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                </div>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import User from "@/classes/User";
import { mapState } from 'vuex';
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
import GalleryPicker from '@/controls/GalleryPicker.vue'
import { API_HELPER } from "@/helpers/api.js";

const COACH = "Coach";
const STUDENT = "Student";

  export default {
  components: { ConfirmationPopUp, FormLoading, SingleOptionDropdown, GalleryPicker },
    props:{    
        baseUser:
        {
            type: Object,
            default: null,
        },
        baseUserName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            currentLanguage: CONSTANTS.supportedLanguages[0],
            user: new User(),
            attemptedSubmit: false,
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            //
            COACH: COACH,
            STUDENT: STUDENT,
        }
    },
    mounted: function()
    {
        this.resetUser();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate required fields
            if(!this.user.firstName) { result['FirstName'] = this.$i18n.t("validateRequiredField"); }
            if(!this.user.lastName) { result['LastName'] = this.$i18n.t("validateRequiredField"); }
            if(!this.user.email) { result['Email'] = this.$i18n.t("validateRequiredField"); }
            if(this.user.role == COACH && !this.user.maxStudents) { result['MaxStudents'] = this.$i18n.t("validateRequiredField"); }

            return result;
        },
        ...mapState('users', ['postUserOutput']),
        ...mapState('users', ['putUserOutput']),
        name: function()
        {
            return this.baseUser || this.baseUserName ? (this.baseUser ? this.baseUser.name : this.baseUserName) : null;
        },
        roles: function() {
            return [
                {key: COACH, label: this.$i18n.t("coach")}, 
                {key: STUDENT, label: this.$i18n.t("student")},
            ];
        }
    },
    methods:{
        resetUser(){
            if(!this.baseUser)
            {
                this.user = new User();
            }
            else
            {
                this.user = deepClone(new User, this.baseUser);  
                this.user.photo = this.user.photoPath ? {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.user.photoPath])} : null;  
                this.user.date = this.user && this.user.dateToLockUser ? this.user.dateToLockUser.substring(0, 10) : null;
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;
            // Emit event
            if(this.user.isValid())
            {
                this.submitting = true;
                if(this.user.photo === undefined || this.user.photo === null) {
                    delete this.user.photo;
                    this.$emit('submit-requested', this.user);
                    return;
                }
                this.$emit('submit-requested', { ...this.user, photo: !this.user.photo.data && !this.user.photo.mime ? null : this.user.photo });
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "UsersList" });
        },
    },
    watch:
    {
        putUserOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        postUserOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseUser: function()
        {
            this.resetUser();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

    .showDropdown
    {
        display: block !important;
    }

    .input-group-append
    {
      height: fit-content;
    }

    img
    {
        width: 50%;
        height: 50%;
    }

</style> 